import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Divider, Row, Col } from "antd";
const UpsellModalHint = (param)=>{
    let { title, description, link, linkText, logo } = param;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Divider, {
                children: title
            }),
            /*#__PURE__*/ _jsxs(Row, {
                wrap: false,
                style: {
                    marginBottom: 10
                },
                children: [
                    /*#__PURE__*/ _jsx(Col, {
                        flex: "auto",
                        children: !!description && /*#__PURE__*/ _jsxs("p", {
                            style: {
                                margin: 0
                            },
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    dangerouslySetInnerHTML: {
                                        __html: description
                                    }
                                }),
                                "\xa0",
                                !!link && !!linkText && /*#__PURE__*/ _jsx("a", {
                                    href: link,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    className: "button-link",
                                    children: linkText
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Col, {
                        flex: "150px",
                        style: {
                            alignSelf: "center"
                        },
                        children: !!logo && /*#__PURE__*/ _jsx("img", {
                            src: logo,
                            style: {
                                maxWidth: "calc(100% - 20px)",
                                height: "auto",
                                marginLeft: 20
                            }
                        })
                    })
                ]
            })
        ]
    });
};
export { UpsellModalHint };
